{
  "files": {
    "messages": {
      "cannotBeDisplayed": "Het document kan niet ingeladen worden.",
      "noFiles": "Er zijn geen documenten beschikbaar"
    }
  }
}
